import styled from 'styled-components/macro';
import { deviceMax, deviceMin } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const MainContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow}

  .right-side .MuiTooltip-popper {
    transform: none;
    left: 0;
  }

  .left-side {
    margin-right: 19px;
    padding-top: 6px;

    @media ${deviceMax.laptopM} {
      margin-right: 30px;
    }

    @media ${deviceMax.mobileL} {
      margin-right: 7px;
    }
    .fullname,
    .status {
      ${FONTS.font16};
      color: ${COLORS.mainColor};
      text-align: start;

      @media ${deviceMin.mobileS} {
        ${FONTS.font12};

      }

      @media ${deviceMin.tablet} {
        ${FONTS.font14};
      }

      @media ${deviceMin.desktop} {
        ${FONTS.font16};
      }

      @media ${deviceMax.laptopM} {
        ${FONTS.font14};
      }

      @media ${deviceMax.tablet} {
        ${FONTS.font16};
      }

      @media ${deviceMax.mobileL} {
        ${FONTS.font12};
        text-align: end;
      }
    }

    .tooltip {
      right: 0;
    }

    .fullname {
      ${FONT_FAMILY.FontMedium}
      margin-bottom: 7px;
      margin-left: 14px;

      @media ${deviceMax.tablet} {
        margin-bottom: 10px;
      }
    }
  }
  .right-side {
    ${FLEX_CONTAINER.FlexRow}


    & .MuiTooltip-tooltip {
      padding: 0;
      border-radius: 5px;
      background: transparent;
      margin-top: 29px;
      left: 0;
      margin-left: 16%;
    }

    & .MuiTooltip-popper {
      pointer-events: all;
    }
  }
`;

export const Avatar = styled.img`
  width: 54px;
  height: 54px;
  object-fit: cover;
  border-radius: 50%;

  @media ${deviceMax.laptopM} {
    width: 54px;
    height: 54px;
  }

  @media ${deviceMax.mobileL} {
    width: 37px;
    height: 37px;
  }
`;

export const ToggleButton = styled.button`
  @media ${deviceMax.mobileL} {
    margin-left: 6px;
  }

  & .MuiSvgIcon-root {
    width: 19px;
    height: 12px;

    @media ${deviceMax.mobileL} {
      width: 11px;
      height: 7px;
    }
  }
`;

export const TooltipContainer = styled.div`
  ${FLEX_CONTAINER.FlexStartRow}
  width: 250px;
  height: auto;
  background: ${COLORS.lightGray};
  border-radius: 5px;
  padding: 0 33px;

  @media ${deviceMax.tablet} {
    background: ${COLORS.lightGray};
    border-radius: 0 0 8px 8px;
    filter: drop-shadow(1px 3px 6px rgba(0, 0, 0, 0.25));
    flex-direction: column;
    height: auto;
    left: 0;
    width: 250px;
    align-items: flex-start;
  }

  @media ${deviceMax.mobileL} {
    width: 250px;
  }
`;

export const MobileMenuItemsContainer = styled.div`
  margin-top: 16px;

  @media ${deviceMax.tablet} {
    ${FLEX_CONTAINER.FlexCenterColumn}
  }

  .mob-desktop {
    margin: 30px 0;

    @media ${deviceMin.mobileS} {
      display: block;
    }

    @media ${deviceMin.laptopM} {
      display: none;
    }
  }

  .logOut {
    @media ${deviceMin.mobileS} {
      margin: 0;
    }

    @media ${deviceMin.tablet} {
      margin: 40px 0;
    }
  }
`;

export const MobileMenuItemContainer = styled.div`
  ${FLEX_CONTAINER.FlexStartRow}

  margin-bottom: 25px;
  cursor: pointer;

  & h6 {
    ${FONTS.font14}
    color: ${COLORS.mainColor};
    margin-left: 14px;
  }

  & .MuiSvgIcon-root {
    width: 13px;
    height: 13px;
    margin-right: 18px;
  }

  & > h6 {
    ${FONTS.font14}
    font-feature-settings: 'pnum' on, 'lnum' on;
    color: ${COLORS.black};
  }

  img {
    width: 15px;
  }

  @media ${deviceMax.mobileL} {
    & > h6 {
      ${FONTS.font12}
    }
  }
`;
